import React, { useMemo } from "react";
var composeProviders = function (providers) { return function (props) {
    var composedProviders = useMemo(function () {
        return providers.reduce(function (acc, CurrentProvider) { return React.createElement(CurrentProvider, null, acc); }, React.createElement(React.Fragment, null, props.children));
    }, [props.children]);
    return composedProviders;
}; };
export default composeProviders;
